// French names for the sticker-shelf rewards and the football cups.
//
// These are laid over the data at DISPLAY time only. `REWARDS[].name` is a KEY:
// `FRIEND_DRAWINGS[r.name]` looks up the drawable friend by its English name, so
// translating the data itself would silently break every "tap a friend to draw
// it" button. Only what the child reads is translated.
//
// Each entry carries the definite article the sentence needs — "Tu as gagné
// **le** Renard", "**la** Souris", "**l'**Éléphant". French elides before a
// vowel, so the article can't be derived from gender alone.

export interface RewardFr {
  name: string;
  /** Definite article, with its trailing space: "le ", "la " or "l'". */
  article: string;
}

/** English reward name (the key into FRIEND_DRAWINGS) → French. */
export const REWARDS_FR: Record<string, RewardFr> = {
  Mouse: { name: "Souris", article: "la " },
  Frog: { name: "Grenouille", article: "la " },
  Hamster: { name: "Hamster", article: "le " },
  Duck: { name: "Canard", article: "le " },
  Bunny: { name: "Lapin", article: "le " },
  Cat: { name: "Chat", article: "le " },
  Fox: { name: "Renard", article: "le " },
  Dog: { name: "Chien", article: "le " },
  Penguin: { name: "Pingouin", article: "le " },
  Pig: { name: "Cochon", article: "le " },
  Pony: { name: "Poney", article: "le " },
  Cow: { name: "Vache", article: "la " },
  Lion: { name: "Lion", article: "le " },
  Horse: { name: "Cheval", article: "le " },
  Bear: { name: "Ours", article: "l'" },
  Elephant: { name: "Éléphant", article: "l'" },
  Whale: { name: "Baleine", article: "la " },
  Dinosaur: { name: "Dinosaure", article: "le " },
};

/** English cup name → French. */
export const CUPS_FR: Record<string, RewardFr> = {
  "Kickoff Cup": { name: "Coupe du coup d'envoi", article: "la " },
  "Bronze Cup": { name: "Coupe de bronze", article: "la " },
  "Silver Cup": { name: "Coupe d'argent", article: "la " },
  "Gold Cup": { name: "Coupe d'or", article: "la " },
  "Champions Cup": { name: "Coupe des champions", article: "la " },
};
